import { connect } from 'react-redux';

import { selectors as userSelectors } from 'dux/user';
import { actionCreators } from '../../dux/instances';
import { actionCreators as act2, selectors } from '../../dux/createInstance';
import AclPopoutItem from './AclForm';

const mapStateToProps = (state) => ({
  myip: selectors.getCreateInstanceState(state).myip,
  userRoles: userSelectors.getIdentityState(state).roles,
});

const mapDispatchToProps = {
  addInstanceAcl: actionCreators.addInstanceAcl,
  getIp: act2.getIp,
  getIpClear: act2.getIpClear,
};

export default connect(mapStateToProps, mapDispatchToProps)(AclPopoutItem);
